export const CurrentUserDependencyTypes = {
  StoreResetter: Symbol.for('CurrentUserStoreResetter'),
  CurrentUserApiDataTransformer: Symbol.for('CurrentUserApiDataTransformer'),
};
